module.exports = __webpack_public_path__ + "static/media/8.c64a5c96.png";